<template>
  <p>
    <el-tooltip :content="info"
                placement="right"
                :disabled="!info">
      <i :class="icon"/>
    </el-tooltip>
    {{text}}<sup>{{sup}}</sup>
  </p>
</template>

<script>
export default {
  props: {
    icon: {
      required: true,
      type: String,
      default: '',
    },
    text: {
      required: true,
      type: String,
      default: '',
    },
    info: {
      type: String,
    },
    sup: {
      type: String,
      default: '',
    },
  },
  name: 'Detail',
};
</script>

<style lang="scss" scoped>
  p {
    line-height: 0.9;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    i {
      width: 14px;
      color: #d2d2d2;
      margin-right: 5px;
    }
  }
</style>
